import React from 'react';
import { ErrorMessage, Field } from 'formik';
import Proptypes from 'prop-types';
import { formErrorMessage } from './FormErrorMessage';
import AsyncSelect from '../select/AsyncSelect';

const FormikAsyncSelect = ({
  name,
  disabled,
  addOnly = false,
  onSelect: onSelectProp,
  ...props
}) => (
  <Field name={name}>
    {({ field: { value }, form: { setFieldValue, touched, errors } }) => (
      <>
        <AsyncSelect
          value={addOnly ? null : value}
          onSelect={(selected) => {
            if (onSelectProp) {
              onSelectProp(selected);
            } else {
              setFieldValue(name, selected);
            }
            if (addOnly) {
              setFieldValue(name, null);
            }
          }}
          clearAfterSelect={addOnly}
          isDisabled={disabled}
          isInvalid={touched[name] && errors[name]}
          {...props}
        />
        <ErrorMessage name={name} render={formErrorMessage} />
      </>
    )}
  </Field>
);

FormikAsyncSelect.propTypes = {
  name: Proptypes.string.isRequired,
  type: Proptypes.string.isRequired,
  placeholder: Proptypes.string,
  disabled: Proptypes.bool,
  addOnly: Proptypes.bool,
  onSelect: Proptypes.func,
};

export default React.memo(FormikAsyncSelect);
